import { Box, Button, Typography } from '@mui/material';
import SystemUpdateAltRoundedIcon from '@mui/icons-material/SystemUpdateAltRounded';

export const BANNER_HEIGHT = 40;

function NewVersionBanner({ serverVersion }) {
  const handleRefresh = async () => {
    // Unregister service workers so their caches are released
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((r) => r.unregister()));
    }
    // Clear Cache Storage API (populated by service workers or the app itself)
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }
    // Reload — index.html has Cache-Control: no-cache so the browser fetches
    // the latest HTML with updated bundle filenames, forcing fresh asset downloads.
    window.location.reload();
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: `${BANNER_HEIGHT}px`,
        zIndex: (theme) => theme.zIndex.tooltip + 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        px: 3,
      }}
    >
      <SystemUpdateAltRoundedIcon fontSize="small" />
      <Typography variant="body2" sx={{ fontWeight: 500, color: 'primary.contrastText' }}>
        A new version is available. Please refresh to get the latest updates.
      </Typography>
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        onClick={handleRefresh}
        sx={{
          ml: 1,
          borderColor: 'rgba(255,255,255,0.5)',
          '&:hover': { borderColor: 'primary.contrastText' },
        }}
      >
        Refresh now
      </Button>
    </Box>
  );
}

export default NewVersionBanner;
